import type { Booking } from '@brighterly/lib-core-types/booking/interfaces'
import type { BookingStore } from './interfaces'

import { useDisciplineStore } from '@stores/discipline'

import { useBookingsApi } from '@api/bookings/index.hook'
import { useFinishedBookingsApi } from '@api/bookings/finished.hook'
import { useCurrentBookingApi } from '@api/bookings/current.hook'

export const actions = {
  setLoading (this: BookingStore, payload: BookingStore['loading']) {
    this.loading = payload
  },
  setLoadingDone (this: BookingStore, payload: BookingStore['loadingDone']) {
    this.loadingDone = payload
  },
  setLoadingFinished (this: BookingStore, payload: BookingStore['loadingFinished']) {
    this.loadingFinished = payload
  },
  setLoadingFinishedDone (this: BookingStore, payload: BookingStore['loadingFinishedDone']) {
    this.loadingFinishedDone = payload
  },
  setCurrentBooking (this: BookingStore, payload: Booking | null): void {
    const disciplineStore = useDisciplineStore()

    if (disciplineStore.isEla) {
      this.currentBookingEla = payload
    } else if (disciplineStore.isMath) {
      this.currentBookingMath = payload
    }
  },
  setBookings (this: BookingStore, payload: Booking[] | null): void {
    const disciplineStore = useDisciplineStore()

    if (disciplineStore.isEla) {
      this.bookingsEla = payload
    } else if (disciplineStore.isMath) {
      this.bookingsMath = payload
    }
  },
  setFinishedBookings (this: BookingStore, payload: Booking[] | null): void {
    const disciplineStore = useDisciplineStore()

    if (disciplineStore.isEla) {
      this.finishedBookingsEla = payload
    } else if (disciplineStore.isMath) {
      this.finishedBookingsMath = payload
    }
  },
  clear (this: BookingStore): void {
    this.bookingsMath = null
    this.bookingsEla = null
  },
  clearFinished (this: BookingStore): void {
    this.finishedBookingsMath = null
    this.finishedBookingsEla = null
  },
  setCountdown (this: BookingStore, payload: BookingStore['countdown']): void {
    this.countdown = payload
  },
  async refreshNow (this: BookingStore, payload: { background: boolean }): Promise<void> {
    const disciplineStore = useDisciplineStore()
    const disciplineId = disciplineStore.activeDiscipline!.id

    await useBookingsApi({
      disciplineId: disciplineId,
      background: payload.background,
    })
  },
  async refreshCurrentNow (this: BookingStore, payload: { background: boolean }): Promise<void> {
    await useCurrentBookingApi({
      background: payload.background,
    })
  },
  async refreshFinishedNow (this: BookingStore, payload: { background: boolean }): Promise<void> {
    const disciplineStore = useDisciplineStore()
    const disciplineId = disciplineStore.activeDiscipline!.id

    await useFinishedBookingsApi({
      disciplineId: disciplineId,
      background: payload.background,
    })
  },
  setModalJoinDemoLesson (this: BookingStore, payload: BookingStore['modalJoinDemoLesson']): void {
    this.modalJoinDemoLesson = payload
  },
  setModalJoinPaidLesson (this: BookingStore, payload: BookingStore['modalJoinPaidLesson']): void {
    this.modalJoinPaidLesson = payload
  },
  setBookingTrigger (this: BookingStore): void {
    this.bookingTrigger++
  },
  setIcsLink (this: BookingStore, payload: BookingStore['icsLink']): void {
    this.icsLink = payload
  },
  setIcsProcessing (this: BookingStore, payload: BookingStore['icsProcessing']): void {
    this.icsProcessing = payload
  },
}
